(function () {
  if (window.__mbbInit) return;
  window.__mbbInit = true;

  function bar() { return document.querySelector('[data-mobile-bottom-bar]'); }

  function setCount(n) {
    document.querySelectorAll('[data-mbb-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('mbb__count--empty', !n);
    });
  }

  function refreshCount() {
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function () {});
  }

  function panel() { return document.querySelector('[data-mbb-search-panel]'); }
  function openSearch() {
    var p = panel();
    if (!p) { window.location.href = '/search'; return; }
    p.hidden = false;
    document.body.classList.add('mbb-search-open');
    var i = p.querySelector('[data-mbb-search-input]');
    if (i) i.focus();
  }
  function closeSearch() {
    var p = panel();
    if (!p) return;
    p.hidden = true;
    document.body.classList.remove('mbb-search-open');
  }

  function init() {
    if (!bar()) return;

    // Search: self-contained full-screen overlay that submits to /search.
    document.addEventListener('click', function (event) {
      var searchBtn = event.target.closest('[data-mbb-search]');
      if (searchBtn) { openSearch(); return; }
      if (event.target.closest('[data-mbb-search-close]')) { closeSearch(); return; }
      // Cart: open the cart drawer when the theme uses one, otherwise follow the link.
      var cartLink = event.target.closest('[data-mbb-cart]');
      if (cartLink) {
        var headerCart = document.getElementById('cart-icon-bubble');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && headerCart) {
          event.preventDefault();
          drawer.open(headerCart);
        }
      }
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount);
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
